import mapiConfig from "../configs/mapi";
import { httpMStepsClient } from "./utils/httpService";
import { logError } from "./utils/logService";
import { getUserInfo } from "./usersService";
import sapiConfig from "../configs/sapi";

//BASE_URL
const MAPI_BASE_URL = mapiConfig.api.domain;
const SAPI_BASE_URL = sapiConfig.api.domain;
const Controller = "/orders";
const FactoryController = "/factory";
const EnquiryController = "/enquiries";
const ChinaShipmentsController = "/shipments";

export const getChinaTrackerDetails = async () => {
  const methodPath = `${Controller}/trackerplus?-60`;

  return await httpMStepsClient({
    baseURL: SAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getMergedTrackerOrders = async (refresh: boolean) => {
  const { given_name, family_name, team } = await getUserInfo();
  const methodPath = `report/china-tracker?days=120&refresh=${refresh}&team=${team}&given_name=${given_name}&family_name=${family_name}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getAllChinaTrackerOrders = async () => {
  const { given_name, family_name, team } = await getUserInfo();
  const methodPath = `${Controller}/tracker?${team}&-60&${given_name}%20${family_name}`;

  return await httpMStepsClient({
    baseURL: SAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getAllChinaTrackerDetailsWithShipments = async (payload: any) => {
  const methodPath = `${FactoryController}/order-shipments`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: payload,
  });
};

export const getTrackerFlagByKey = async (key: string) => {
  const methodPath = `${FactoryController}/flag/order/${key}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getTrackerInterruptsByKey = async (key: string) => {
  const methodPath = `${FactoryController}/run-orders/interrupts/${key}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getAllFactoryFlags = async () => {
  const methodPath = `${FactoryController}/flag/order`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getFactoryFlagsByKey = async (key: string) => {
  const methodPath = `${FactoryController}/flag/order/${key}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const flagTrackerOrder = async (requestBody: any) => {
  const methodPath = `${FactoryController}/flag/order`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: requestBody,
  });
};

export const addFactoryOrderDetails = async (requestBody: any) => {
  const methodPath = `${FactoryController}/order/details`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: requestBody,
  });
};

export const updateFactoryOrderDetails = async (
  orderId: string,
  requestBody: any,
) => {
  const methodPath = `${FactoryController}/order/details/${orderId}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "PATCH",
    path: methodPath,
    body: requestBody,
  });
};

export const updateChinaOrderPriority = async (requestBody: any) => {
  const methodPath = `${FactoryController}/order/priority`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "PATCH",
    path: methodPath,
    body: requestBody,
  });
};

export const getAllChinaIncomingFactoryOrders = async () => {
  const methodPath = `${FactoryController}/order/incoming`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getAllChinaPriorityFactoryOrders = async () => {
  const methodPath = `${FactoryController}/order/priority`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getFactoryOrderDetailsByKey = async (key: string) => {
  const methodPath = `${FactoryController}/order/details/${key}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getAllFactoryOrderDetails = async () => {
  const methodPath = `${FactoryController}/order/details`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getTrackerEnquiriesByKey = async (key: string) => {
  const methodPath = `${EnquiryController}/${key}/CHINA_TRACKER`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getAllChinaTrackerEnquiries = async () => {
  const methodPath = `${EnquiryController}?enquiryTrackerType=CHINA_TRACKER`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const searchTrackerEnquiriesByKey = async (
  key: string,
  search: string,
) => {
  const methodPath = `${EnquiryController}/${key}/CHINA_TRACKER?search=${search}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const searchTrackerFlagsByKey = async (key: string, search: string) => {
  const methodPath = `${FactoryController}/flag/order/${key}?search=${search}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const searchTrackerInterruptsByKey = async (
  key: string,
  search: string,
) => {
  const methodPath = `${FactoryController}/run-orders/interrupts/${key}?search=${search}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const addTrackerEnquiry = async (requestBody: any) => {
  const methodPath = `${EnquiryController}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: requestBody,
  });
};

export const approveIncomingOrder = async (requestBody: any) => {
  const methodPath = `${FactoryController}/order/incoming/bulk`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: requestBody,
  });
};

export const approveCancelledOrderBulk = async (requestBody: any) => {
  const methodPath = `${FactoryController}/approve-cancel-order/bulk`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: requestBody,
  });
};

export const approveSingleIncomingOrder = async (requestBody: any) => {
  const methodPath = `${FactoryController}/order/incoming`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: requestBody,
  });
};

export const updateIncomingOrder = async (requestBody: any) => {
  const methodPath = `${FactoryController}/order/incoming`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "PATCH",
    path: methodPath,
    body: requestBody,
  });
};

export const updateBulkIncomingOrder = async (requestBody: any) => {
  const methodPath = `${FactoryController}/order/incoming/bulk`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "PATCH",
    path: methodPath,
    body: requestBody,
  });
};

export const getChinaOrganizationalUsers = async () => {
  const methodPath = `${FactoryController}/checklist/users?team=purchasing`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getAllChinaCancelledOrders = async () => {
  const methodPath = `${FactoryController}/approve-cancel-order`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const updateChinaChecklist = async (requestBody: any) => {
  const methodPath = `${FactoryController}/checklist/users`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "PATCH",
    path: methodPath,
    body: requestBody,
  });
};

export const fetchRejectedHistoryChinaOrder = async (key: string) => {
  const methodPath = `${FactoryController}/reject/order/${key}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const fetchAllRejectedHistoryChinaOrder = async () => {
  const methodPath = `${FactoryController}/reject/order`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getChinaTrackerShipmentDetailsByDetailId = async (
  factoryOrderDetailId: string,
) => {
  const methodPath = `${FactoryController}/shipments/${factoryOrderDetailId}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const createFactoryRunShipment = async (requestBody: any) => {
  const methodPath = `${FactoryController}/shipments`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: requestBody,
  });
};

export const updateFactoryRunShipment = async (
  requestBody: any,
  _id: string,
) => {
  const methodPath = `${FactoryController}/shipments/${_id}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "PATCH",
    path: methodPath,
    body: requestBody,
  });
};

export const createDirectFactoryRunShipment = async (requestBody: any) => {
  const methodPath = `${FactoryController}/shipments/direct`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: requestBody,
  });
};

export const deleteFactoryRunShipment = async (_id: string) => {
  const methodPath = `${FactoryController}/shipments/${_id}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "DELETE",
    path: methodPath,
  });
};

export const interruptRunOrderDetail = async (requestBody: any) => {
  const methodPath = `${FactoryController}/run-orders/interrupt`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: requestBody,
  });
};

export const getChinaShipments = async (
  page: number,
  pageSize: number,
  sort: any,
  status: string,
  search: string,
  dateFrom: string | null | undefined,
  dateTo: string | null | undefined,
) => {
  let methodPath = `${ChinaShipmentsController}?page=${page}&pageSize=${pageSize}&sort=${sort}&status=${status}&search=${search}`;

  if (dateFrom && dateTo) {
    methodPath = methodPath + `&dateFrom=${dateFrom}&dateTo=${dateTo}`;
  }
  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getChinaIncomingShipments = async (
  page: number,
  pageSize: number,
  sort: any,
  status: string,
  search: string,
) => {
  const methodPath = `${ChinaShipmentsController}/incoming?page=${page}&pageSize=${pageSize}&sort=${sort}&status=${status}&search=${search}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const approveIncomingChinaShipment = async (requestBody: any) => {
  const methodPath = `${ChinaShipmentsController}/approve-shipment`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: requestBody,
  });
};

export const getChinaShipmentsByContainerNo = async (containerNo: string) => {
  const methodPath = `${ChinaShipmentsController}/container/${containerNo}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const generateChinaShipment = async (requestBody: any) => {
  const methodPath = `${ChinaShipmentsController}/generate-shipment`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: requestBody,
  });
};

export const updateGeneratedChinaShipment = async (
  _id: string,
  payload: any,
) => {
  const methodPath = `${ChinaShipmentsController}/update-shipment/${_id}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "PATCH",
    path: methodPath,
    body: payload,
  });
};
